import { RootState } from "@/store/store";
import { createSelector } from "@reduxjs/toolkit";


export const getDebugState = (state: RootState) => state.debug ?? undefined;

export const getImporterDebug = createSelector(
    getDebugState,
    (debug) => debug?.importer as Record<string, string | null> | undefined,
);
